import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe для форматирования числа просмотров в стиле Instagram.
 *
 * Примеры:
 * - 999 → "999"
 * - 1000 → "1K"
 * - 1300 → "1.3K"
 * - 10500 → "10.5K"
 * - 100000 → "100K"
 * - 1000000 → "1M"
 * - 1500000 → "1.5M"
 * - 1000000000 → "1B"
 */
@Pipe({
  name: 'viewsFormat',
  pure: true
})
export class ViewsFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '0';
    }

    const absValue = Math.abs(value);
    const sign = value < 0 ? '-' : '';

    if (absValue < 1000) {
      return sign + absValue.toString();
    }

    if (absValue < 1000000) {
      // Thousands (K)
      return sign + this.formatNumber(absValue / 1000) + 'K';
    }

    if (absValue < 1000000000) {
      // Millions (M)
      return sign + this.formatNumber(absValue / 1000000) + 'M';
    }

    // Billions (B)
    return sign + this.formatNumber(absValue / 1000000000) + 'B';
  }

  private formatNumber(num: number): string {
    // Round to 1 decimal place
    const rounded = Math.floor(num * 10) / 10;

    // If number is integer (e.g. 1.0), return without fractional part
    if (rounded % 1 === 0) {
      return rounded.toString();
    }

    // Otherwise return with one decimal place
    return rounded.toFixed(1);
  }
}
